import logo from '../logo.svg';
import '../styles/Header.css';

const Header = ({ translations, language, currentPage, onNavigate }) => {
  const t = translations[language];

  const navItems = [
    { id: 'home', label: 'MobiDeal', isMain: true },
    { id: 'plans', label: t.navPlans || 'Plans', tag: 'Beta' },
    { id: 'calculator', label: t.navCalculator || 'Calculator' },
    { id: 'chatbot', label: t.navChatbot || 'Chatbot', tag: 'Alpha', disabled: true, hidden: true },
    { id: 'faq', label: t.navFaq || 'FAQ' }
  ];

  return (
    <div className="header">
      <div className="header-content">
        <div className="header-left">
          <div className="header-title">
            <img src={logo} alt="Logo" className="header-icon" />
            <h1>{t.appTitle.split('\n').map((line, i) => (
              <span key={i}>
                {line}
                {i < t.appTitle.split('\n').length - 1 && <br />}
              </span>
            ))}</h1>
          </div>
          <p className="header-subtitle">{t.headerSubtitle}</p>
        </div>

        {/* Integrated Navigation */}
        <nav className="header-nav">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => !item.disabled && onNavigate(item.id)}
              className={`header-nav-item ${item.isMain ? 'main' : ''} ${currentPage === item.id ? 'active' : ''} ${item.disabled ? 'disabled' : ''} ${item.hidden ? 'hidden' : ''}`}
              disabled={item.disabled}
              style={item.hidden ? { display: 'none' } : {}}
            >
              {item.label}
              {item.tag && <span className="header-nav-tag">{item.tag}</span>}
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default Header;